/**
 * Spaltenaufteilung des Produkt-Grids auf Warengruppen- und Suchergebnisseiten.
 *
 * Einzige Stelle fuer diese Breakpoints: Die Warengruppen-Banner (Legacy, fxxlSetWarengruppeBanners()
 * im Critical-JS) und die Kampagnen-Banner (@fxxl/fxxl_campaign_banners) lesen sie von hier, damit
 * beide bei einer Aenderung am Grid nicht auseinanderlaufen.
 *
 * Warum ein eigenes, kleines Modul:
 * - Die Breakpoints beschreiben das Produkt-Grid, nicht eine der beiden Banner-Arten.
 * - Der Legacy-Code im Critical-JS braucht sie, deshalb wird dieses Modul eager in 000_load_module.js
 *   geladen. Es bleibt bewusst klein, damit das Kampagnen-Modul selbst lazy geladen werden kann.
 *
 * columns:   Produkte je Reihe
 * itemCount: Produkte vor einem Warengruppen-Banner je Position (columns x Reihen)
 */
const warengruppeGridConditions = [
    { startWidth: 1420, endWidth: 99999, columns: 4, itemCount: 12 },
    { startWidth: 1100, endWidth:  1419, columns: 3, itemCount:  9 },
    { startWidth:  980, endWidth:  1099, columns: 2, itemCount: 12 },
    { startWidth:  800, endWidth:   979, columns: 3, itemCount:  9 },
    { startWidth:  600, endWidth:   799, columns: 2, itemCount: 12 },
    { startWidth:    1, endWidth:   599, columns: 1, itemCount:  6 },
];

/**
 * Grid-Angaben fuer die aktuelle Breite, undefined bei Breite 0 (z. B. ausgeblendeter Body).
 *
 * @param {number} width document.body.offsetWidth
 * @returns {{startWidth: number, endWidth: number, columns: number, itemCount: number}|undefined}
 */
export function getWarengruppeGridCondition(width) {
    return warengruppeGridConditions.find(
        (condition) => width >= condition.startWidth && width <= condition.endWidth
    );
}
